import { HospitalInfoResponseDto } from "@/data/dto/hospital-info-reponse-dto";
import { HospitalInfoValidResponseDto } from "@/data/dto/hospital-info-valid-reponse-dto";
import { AddHospitalRequestPayload } from "@/data/payload/admin/add-hospital-request-payload";
import { DeleteHospitalRequestPayload } from "@/data/payload/admin/delete-hospital-request-payload";
import { HospitalInfoRequestPayload } from "@/data/payload/hospital-info-request-payload";
import { URLList } from "@/data/url_list";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";

/**
 * 병원 관련 API 요청을 담당하는 데이터 소스 클래스
 */
export class HospitalSource {
  constructor(private readonly client: FetchApiClientMethod) {}

  /**
   * 병원 정보 조회
   * @param payload - 병원 정보 조회에 필요한 정보
   * @returns 성공 시 HospitalInfoResponseDto, 실패 시 SATError
   */
  async getHospitalInfo(
    payload: HospitalInfoRequestPayload
  ): Promise<SATResult<HospitalInfoResponseDto, SATError>> {
    try {
      const url = `${URLList.HOSPITAL.GET_HOSPITAL_INFO}/${payload.hospitalCode}`;
      console.log("[HospitalSource] :: getHospitalInfo :: 병원 정보 조회 시작", url);
      const response = await this.client.get(url);
      console.log("[HospitalSource] :: getHospitalInfo :: 병원 정보 조회 성공", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[HospitalSource] :: getHospitalInfo :: 병원 정보 조회 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[HospitalSource] :: getHospitalInfo | ", satError);
      return SATResult.failure(satError);
    }
  }

  /**
   * 병원 정보 유효성 검증
   * @param payload - 병원 정보 유효성 검증에 필요한 정보
   * @returns 성공 시 HospitalInfoValidResponseDto, 실패 시 SATError
   */
  async validateHospitalInfo(
    payload: HospitalInfoRequestPayload
  ): Promise<SATResult<HospitalInfoValidResponseDto, SATError>> {
    try {
      const url = `${URLList.HOSPITAL.GET_HOSPITAL_INFO}/${payload.hospitalCode}`;
      console.log("[HospitalSource] :: validateHospitalInfo :: 병원 정보 유효성 검증 시작", url);
      const response = await this.client.get(url);
      console.log(
        "[HospitalSource] :: validateHospitalInfo :: 병원 정보 유효성 검증 성공",
        response.data
      );
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error(
        "[HospitalSource] :: validateHospitalInfo :: 병원 정보 유효성 검증 실패",
        error
      );
      const satError = errorConverter.convertError(error);
      console.log("[HospitalSource] :: validateHospitalInfo | ", satError);
      return SATResult.failure(satError);
    }
  }

  /**
   * 병원 정보 추가
   * @param payload - 병원 정보 추가에 필요한 정보
   * @returns 성공 시 HospitalInfoResponseDto, 실패 시 SATError
   */
  async addHospitalInfo(
    payload: AddHospitalRequestPayload
  ): Promise<SATResult<void, SATError>> {
    try {
      const url = URLList.HOSPITAL.POST_ADD_HOSPITAL;
      console.log("[HospitalSource] :: addHospitalInfo :: 병원 정보 추가 시작", url);
      const response = await this.client.post(url, payload);
      console.log("[HospitalSource] :: addHospitalInfo :: 병원 정보 추가 성공", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[HospitalSource] :: addHospitalInfo :: 병원 정보 추가 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[HospitalSource] :: addHospitalInfo | ", satError);
      return SATResult.failure(satError);
    }
  }

  /**
   * 병원 정보 목록 조회
   * @returns 성공 시 HospitalInfoResponseDto, 실패 시 SATError
   */
  async getHospitalList(): Promise<SATResult<HospitalInfoResponseDto[], SATError>> {
    try {
      const url = URLList.HOSPITAL.GET_HOSPITAL_LIST;
      console.log("[HospitalSource] :: getHospitalList :: 병원 정보 목록 조회 시작", url);
      const response = await this.client.get(url);
      console.log("[HospitalSource] :: getHospitalList :: 병원 정보 목록 조회 성공", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[HospitalSource] :: getHospitalList :: 병원 정보 목록 조회 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[HospitalSource] :: getHospitalList | ", satError);
      return SATResult.failure(satError);
    }
  }

  async deleteHospitalInfo(
    payload: DeleteHospitalRequestPayload
  ): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.HOSPITAL.DELETE_HOSPITAL}/${payload.hospitalCode}`;
      console.log("[HospitalSource] :: deleteHospitalInfo :: 병원 정보 삭제 시작", url);
      const response = await this.client.delete(url);
      console.log("[HospitalSource] :: deleteHospitalInfo :: 병원 정보 삭제 성공", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[HospitalSource] :: deleteHospitalInfo :: 병원 정보 삭제 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[HospitalSource] :: deleteHospitalInfo | ", satError);
      return SATResult.failure(satError);
    }
  }
}
